import React, { useEffect, useState } from "react";
import { request } from "../../../utils/request";
import { auth } from "../../../utils/auth";
import { formatCurrency } from "../../../utils/helpers";
import dayjs from "dayjs";

const PrintSolicitudPago = () => {
    const [compras, setCompras] = useState([]);
    const [contactos, setContactos] = useState([]);
    const [listo, setListo] = useState(false);

    const getCompras = async () => {
        const { data } = await request("cuentas-por-pagar" + (window.location.search === '' ? '?' : window.location.search + '&') + 'limit=100000');

        setCompras(data);
        setContactos([...(new Set(data.map(item => item.contacto)))]);
        setListo(true);
    };

    useEffect(() => {
        getCompras();
    }, []);

    // Espera a que el estado con los datos ya esté reflejado en el DOM
    // antes de abrir el diálogo de impresión.
    useEffect(() => {
        if (listo) {
            window.print();
        }
    }, [listo]);

    const user = auth.getUser();
    const sucursal = user.sucursales.filter(
        (suc) => suc.id === user.sucursalActual
    )[0];

    const balance = compras.reduce((preview, compra) => preview + compra.porPagar, 0);

    return <>
        <div className="row">
            <h2 className="col-md-12 text-center m-b-5">
            {sucursal.nombre}
            </h2>
            <div className="col-md-12 text-center uppercase"><strong>Solicitud de pago</strong></div>
            <div className="col-md-12 text-center">
                {sucursal.direccion} •{" "}
                {new Date().toLocaleString()}
            </div>
           
            <div className="col-md-12 text-right p-b-10" style={{fontSize: 'larger'}}>
                <div className="float-left">
                    TOTAL CUENTAS POR PAGAR: {compras.length}
                </div>

                <div className="float-right">
                    <strong>BALANCE TOTAL: {formatCurrency(balance)}</strong>
                </div>
            </div>
        </div>

        {contactos.map((contacto) => <ClientTable contacto={contacto} compras={compras.filter((compra) => compra.contacto === contacto)} />)}
    </>;
};

const ClientTable = ({ compras, contacto }) => {
    const balance = compras.reduce((preview, compra) => preview + compra.porPagar, 0);

    return <>
        <h3 className="mt-3">{contacto}</h3>

        <table className="table" style={{fontSize: 'larger'}}>
            <thead>
                <tr>
                    <th>NCF/Numero</th>
                    <th>Tipo</th>
                    <th>Suplidor</th>
                    <th width="165px">Fecha</th>
                    <th className="text-right" width="165px">Vencimiento</th>
                    <th className="text-right">Monto</th>
                    <th className="text-right">Balance</th>
                </tr>
            </thead>

            <tbody>
                {compras.map((compra) => <tr>
                    <td>{compra.ncf}{compra.numero && '/' + compra.numero}</td>
                    <td className="text-capitalize">{compra.tipo}</td>
                    <td>{compra.contacto}</td>
                    <td>
                        {dayjs(compra.fecha).format("DD/MM/YYYY")}{" "}
                        <span>
                            <div>
                                {dayjs().startOf("day").diff(dayjs(compra.fecha).startOf("day"), "day")}{" "}
                                días transcurridos
                            </div>
                        </span>
                    </td>
                    <td className="text-right">
                        {dayjs(compra.fechaVencimiento).format("DD/MM/YYYY")}{" "}
                        <div>
                            {compra.plazo?.dias || 0} Días
                        </div>
                    </td>
                    <td className="text-right">
                        {formatCurrency(compra.total)}
                    </td>
                    <td className="text-right">
                        {formatCurrency(compra.porPagar)}
                    </td>
                </tr>)}
            </tbody>
        </table>

        <div className="col-md-12 text-right p-b-10 mb-5" style={{fontSize: 'larger'}}>
            <div className="float-left">
                TOTAL CUENTAS POR PAGAR: {compras.length}
            </div>

            <div className="float-right">
                <strong>BALANCE TOTAL: {formatCurrency(balance)}</strong> 
            </div>
        </div>
    </>
};

export default PrintSolicitudPago;